import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiPathLogoComponent } from '@components/ui-logo/ui-logo.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
    ],
    declarations: [
        UiPathLogoComponent,
    ],
    exports: [
        UiPathLogoComponent,
    ],
})
export class UiPathLogoModule { }
